import basic from  './basic'
import service from  './service'
import traffic from  './traffic'
// import module from  './module'
import tha from  './tha'
import engagement from  './engagement'

const en = {
    ...basic,
    ...service,
    ...traffic,
    // ...module,
    ...tha,
    ...engagement
}

export default en
